import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Merchant Config',
    url: '/merchant-config',
    iconComponent: { name: 'cil-layers' },
    children: [
      {
        name: 'Payment Method Config',
        url: '/merchant-config/payment-method-config',
        icon: 'nav-icon-bullet',
      }
    ]
  },
  {
    name: 'Payments',
    url: '/payments',
    iconComponent: { name: 'cil-layers' },
    children: [
      {
        name: 'Remittance',
        url: '/payments/remittance',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Manual Adjustments',
        url: '/payments/manual-adjustments',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Manual Deductions',
        url: '/payments/manual-deductions',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Advanced Withdrawal',
        url: '/payments/daily-withdrawal',
        icon: 'nav-icon-bullet',
      },
      {
        name: 'Remittance Whitelisting',
        url: '/payments/remittance-whitelisting',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    name: 'Orders',
    url: '/orders',
    iconComponent: { name: 'cil-layers' },
    children: [
      {
        name: 'Core Orders',
        url: '/orders/core-orders',
        icon: 'nav-icon-bullet',
      },
      // {
      //   name: 'Shipment Management',
      //   url: '/orders/shipment-management',
      //   icon: 'nav-icon-bullet',
      // },
    ],
  },
  {
    name: 'Push Notification',
    url: '/push-notifications',
    iconComponent: { name: 'cil-layers' },
    children: [
      {
        name: 'Push Notification List',
        url: '/push-notifications/list',
      },
    ],
  },
  {
    name: 'Vouchers',
    url: '/vouchers',
    iconComponent: { name: 'cil-layers' },
    children: [
      {
        name: 'Voucher Management',
        url: '/voucher/vouchers',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    name: 'Banners',
    url: '/banner',
    iconComponent: { name: 'cil-layers' },
    children: [
      {
        name: 'Banner Management',
        url: '/banner/banner',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    name: 'Refunds',
    url: '/refund',
    iconComponent: { name: 'cil-layers' },
    children: [
      {
        name: 'All Refunds',
        url: '/refund/all-refunds',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    name: 'Documents',
    url: '/documents',
    iconComponent: {name : 'cil-layers'},
    children: [
      {
        name: 'All Documents',
        url: '/documents/all',
        icon: 'nav-icon-bullet'
      }
    ]
  }
];
